// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__U52RL","edit":"styles_edit__3pp06","tableRow":"styles_tableRow__GUtw-","sorted":"styles_sorted__3R3AB"};